import React from 'react';
import PropTypes from 'prop-types';

import {
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';

/* eslint-disable react/forbid-prop-types */
const propTypes = {
  enabled: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};

const Overlay = (props) => {
  const { enabled, children, message } = props;

  const getTooltip = () => {
    return (
      <Tooltip id={message}>
        <strong>{message}</strong>
      </Tooltip>
    );
  };

  if (enabled) {
    return (
      <OverlayTrigger placement="top" overlay={getTooltip()}>
        <div>
          {children}
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  );
};

Overlay.propTypes = propTypes;

export default Overlay;
